<!--
右下角浮动按钮
最近更新：20200318
-->
<template>
<!--   v-if="!(from_giant_app == 1 || getQueryString('from_found'))"-->
<div class="float_tools">
  <router-link class="btn btn_backhome" title="回到首页" :to="backhomeUrl" v-show="innerShowBackhome"><i class="material-icons">&#xe88a;</i></router-link>
  <router-link class="btn btn_cart" title="购物车" :to="{name: 'Cart'}" v-show="innerShowCart"><i class="material-icons">&#xe547;</i><em class="badge badge_color_1" v-if="cartCount">{{cartCount}}</em></router-link>
  <router-link class="btn btn_me" title="我" :to="{name: 'Me'}" v-show="innerShowMe"><i class="material-icons">&#xe7fd;</i></router-link>
  <!--<a class="btn btn_back" title="返回上一页" @click="funBack"><i class="material-icons">&#xe5c4;</i></a>
  <a class="btn btn_refresh" title="刷新页面" @click="funReload"><i class="material-icons">&#xe5d5;</i></a>-->
  <slot name="extra">
  </slot>
</div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'FloatTools',
  components: {},
  props: ['showBackhome', 'showCart', 'showMe'],
  data () {
    return {
      innerShowBackhome: true,
      innerShowCart: true,
      innerShowMe: true,
      backhomeUrl: '/',
      tmpName: 'FloatTools',
      from_giant_app: -1
    }
  },
  computed: {
    ...mapState({
      cartCount: state => state.cartCount
    }),
  },
  watch: {},
  created() {
    if(this.getQueryString('from_giant_app')){
      localStorage.setItem('from_giant_app', this.$route.query.from_giant_app)
    }
    const _this = this;
    //是否显示【回首页】
    if( typeof _this.showBackhome != 'undefined' ){
      if( _this.showBackhome ){
        _this.innerShowBackhome = true;
      } else {
        _this.innerShowBackhome = false;
      }
    }

    //是否显示【购物车】
    if( typeof _this.showCart != 'undefined' ){
      if( _this.showCart ){
        _this.innerShowCart = true;
      } else {
        _this.innerShowCart = false;
      }
    }
    if( _this.innerShowCart ){
      _this.funForceUpdate();//拉取购物车商品数量
    }

    //是否显示【我的】 // 骑行App 环境下不显示[我的]浮窗
    if(_this.$store.state.browser.giantapp && _this.checkGiantAppVersion('4.0.0',"4.0.0") && (!_this.checkGiantAppEqualVersion('5.0.0'))){
      _this.innerShowMe = false;
    }else{
      if( typeof _this.showMe != 'undefined' ){
        if( _this.showMe ){
          _this.innerShowMe = true;
        } else {
          _this.innerShowMe = false;
        }
      }
    }
    // 骑行App 环境下 订单页面不显示浮窗
    if(_this.$route.query.from_giant_app && _this.checkGiantAppVersion('4.0.0',"4.0.0") && (!_this.checkGiantAppEqualVersion('5.0.0'))){
      _this.innerShowBackhome = false
      _this.innerShowCart = false
    }
    //总部角色不显示【购物车】
    //if( _this.GLOBAL.loginUser.roletype == 2 ) _this.innerShowCart = false;

  },
  mounted() {
    this.from_giant_app = localStorage.getItem('from_giant_app')
  },
  destroyed() {},
  methods: {
    funBack(){
      this.$router.go(-1);
    },
    funReload(){
      location.reload(true);
    },
    //拉取购物车商品数量，并强制刷新
    funForceUpdate(){
      const _this = this;
      _this.getCartCount(function(){
        _this.$forceUpdate();
      });//拉取购物车商品数量
    },
  }
}
</script>

<style lang="less">
/** 右下角浮动按钮 通用 **/
.float_tools {
  display: block;
  position: fixed;
  right: 0;
  bottom: 60px;
  z-index: 10;
  font-size: 0;
  width: 40px;
}
.float_tools .btn {
  border-radius: 100px;
  width: 80px;
  height: 40px;
  padding-right: 35px;
  line-height: 40px;
  opacity: .9;
  background-color: #333;
  color: #fff;
  margin-top: 5px;
  position: relative;
}
.float_tools .btn > .material-icons {
  line-height: inherit;
  vertical-align: top;
}
.float_tools .btn:hover {
  opacity: 1;
}
.float_tools .btn > .badge {
  position: absolute;
  padding: 0 4px;
  min-width: 24px;
  text-align: center;
  border-radius: 100px;
  transform: scale(0.8);
  top: -5px;
  right: 35px;
}
.float_tools .btn_scroll_to_top {
  display: none;
}
.float_tools .btn_scroll_to_top.active {
  display: block;
  animation: scroll_to_top_ani .3s ease-out ;
}
@keyframes scroll_to_top_ani {
  0% {
    transform: scale(0);
  }
  80% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.float_tools .btn_backhome {
  background-color: #4E66FF;
}
.float_tools .btn_cart {
  /*background-color:#ff7e00;*/
}
.float_tools .btn_favorite {
  background-color: rgba(239, 58, 58, .5);
  text-shadow: 0 0 10px #ef3a3a;
  box-shadow: inset 0 0 20px rgba(239, 58, 58, .5);
}
.float_tools .btn_favorite.active {
  background-color: #ef3a3a;
  color: #fff;
  text-shadow: none;
}
.float_tools .btn_favorite.active .no,
.float_tools .btn_favorite .ok {
  display: none;
}
.float_tools .btn_favorite.active .ok {
  display: inline-block;
}
.float_tools .btn_favorite.active {
  animation: scroll_to_top_ani .3s ease-out ;
}
.float_tools .btn_me {
  background-color: #4e66ff;
}
</style>



// WEBPACK FOOTER //
// src/components/FloatTools.vue